import { Component, Input, OnInit } from '@angular/core';
import { IUserInfoField } from 'src/app/interfaces/embedding-options.interface';

const LOCAL_STORAGE_KEY = 'cb_user_info';

@Component({
  selector: 'app-user-info-query',
  templateUrl: './user-info-query.component.html',
  styleUrls: ['./user-info-query.component.scss']
})
export class UserInfoQueryComponent implements OnInit {
  private _requiredFields?: IUserInfoField[];

  @Input() set requiredFields(value: IUserInfoField[] | undefined) {
    this._requiredFields = value;
    this.ngOnInit();
  }
  get requiredFields(): IUserInfoField[] | undefined {
    return this._requiredFields;
  }

  showUserInfoPromptModal: boolean = false;

  get userInfoValid(): boolean {
    return !this.requiredFields || this.requiredFields.every((field) => {
      switch (field.type) {
        case 'email':
          return !!field.value && /.+@.+\..+/.test(field.value);
        case 'phone':
          return !!field.value && /^\d{10}$/.test(field.value);
        default:
          return !!field.value;
      }
    });
  }

  constructor() {}

  ngOnInit(): void {
    if (this.requiredFields && this.requiredFields.length > 0) {
      this.requiredFields?.forEach((field) => {
        field.value = this.getUserInfo(field.key);
      });

      this.showUserInfoPromptModal = this.requiredFields?.some((field) => !field.value) || false;
    }
  }

  getUserInfo(key: string): string {
    const userInfo = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY) || '{}');
    return userInfo[key] || '';
  }

  saveUserInfo(): void {
    this.requiredFields?.forEach((field) => {
      this.setUserInfo(field.key, field.value);
    });
  }

  setUserInfo(key: string, value: string): void {
    const userInfo = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY) || '{}');
    userInfo[key] = value;
    localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(userInfo));

    const field = this.requiredFields?.find((field) => field.key === key);
    if (field) {
      field.value = value;
    }

    this.showUserInfoPromptModal = this.requiredFields?.some((field) => !field.value) || false;
  }
}
